"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const filterPostsByCategory_1 = require("@/util/filterPostsByCategory");
const PostIndexItem_1 = __importDefault(require("@comp/PostIndexItem"));
/**
 * @param {Post[]} posts 렌더링할 포스트의 배열
 * @param {string} selectedCategory 현재 선택된 카테고리
 *
 */
function createPostsContent(posts, selectedCategory) {
    const filteredPosts = (0, filterPostsByCategory_1.filterPostsByCategory)(posts, selectedCategory);
    const filteredPostItemsHtml = (0, PostIndexItem_1.default)(filteredPosts);
    //중복된 카테고리 목록 필터링
    const uniqueCategories = [
        "All",
        ...new Set(posts.map((post) => post.category)),
    ];
    const uniqueCategoriesMap = uniqueCategories.map((v) => {
        return `<div class="py-2 cursor-pointer whitespace-nowrap ${v === selectedCategory
            ? "text-white-200 shadow-[inset_0_-2px_0_#ffb86b]"
            : "text-muted hover:text-white-200"}" data-category="${v}">${v}</div>`;
    });
    return `
  <section class="w-full px-4">
      <div class="flex flex-row overflow-x-auto overflow-y-hidden gap-x-5 scrollbar-hide border-b border-solid border-line mb-2 text-body font-GmarketSansMedium">
        ${uniqueCategoriesMap.join("")}
      </div>
      ${filteredPostItemsHtml}
  </section>
  `;
}
exports.default = createPostsContent;
